import styles from "../Eleginos-para-tu-proyecto/Eleginos-para-tu-proyecto.module.css"
import React from "react";
function EleginosParaTuProyecto() {
    return (
        <div className={styles['contenedor-eleginos']}>

            <h3 className={styles['h3-titulo-eleginos']}>
                ¿Por qué elegirnos para realizar tu proyecto?
            </h3>

            <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Culpa ex dolorum esse consequuntur maiores numquam repellendus
                illo sunt? Sequi delectus veritatis tempora ducimus dolorem adipisci
                numquam provident, asperiores debitis rerum?.
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa ex dolorum
                esse consequuntur maiores numquam repellendus illo sunt? Sequi delectus
                veritatis tempora ducimus dolorem adipisci numquam provident, asperiores
                debitis rerum?, Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Culpa ex dolorum esse consequuntur maiores numquam repellendus illo sunt?
                Sequi delectus veritatis tempora ducimus dolorem adipisci numquam provident,
                asperiores debitis rerum?

            </p>

        </div>

    )
}

export default EleginosParaTuProyecto;